import { v4 as uuidv4 } from "uuid";
import {
  SET_NEW_PATIENT,
  SET_INIT_PATIENT,
  SET_NEW_PATIENT_ID,
} from "../actions";

export const INIT_STATE = {
  PatientDetails: {
    PatientID: parseInt(Math.random()*1000000000, 10),
    SessionID: uuidv4(),
    Branch: "",
    FirstName: "",
    LastName: "",
    Sex: "Male",
    IDNumber: "",
    PhoneNumber: "",
    Email: "",
    DateOfBirthRaw: "",
    DateOfBirthTimestamp: "",
    Initials: "",
    Title: "Mr",
    Allergies: "-",
    PhysicalAddress: null,
    PostalAddress: null,
  },

  EmploymentDetails: {
    ContactPerson: "",
    EmployerContactNumber: "",
    Occupation: "",
    CompanyName: "",
    CompanyNumber: "",
    EmployerPhysicalAddress: "",
  },

  MedicalAidDetails: {
    DependentCode: 1,
    MedicalAidMemberRelationToPatient: "",
    MedicalAidMemberTitle:"",
    MedicalAidMemberFirstName: "",
    MedicalAidMemberLastName: "",
    MedicalAidMemberInitials:"",
    MedicalAidMemberIDNumber: "",
    MedicalAidMemberPhoneNumber: "",
    MedicalAidMemberPostalAddress: "",
    MedicalAidName: "",
    MedicalAidPlan: "",
    MedicalAidNumber: "",
    MedicalAidVatNumber: "",
    MedicalAidMemberMemberEmployerName:"",
    MedicalAidMemberMemberWorkDepartment:"",
    MedicalAidMemberMemberOccupation:"",
    MedicalAidMemberMemberWorkPhone:"",
    MedicalAidMemberMemberWorkAddress:"",
  },
  Documents: {
    ID_DOC: null,
    MEDICAL_AID_DOC: null,
    REF_NOTE_DOC: null,
    OTHER_DOC_ONE: null,
    OTHER_DOC_TWO: null,
    OTHER_DOC_THREE: null,
    OTHER_DOC_FOUR: null,
    OTHER_DOC_FIVE: null,
    OTHER_DOC_SIX: null,
    OTHER_DOC_SEVEN: null,
    OTHER_DOC_EIGHT: null,
    OTHER_DOC_NINE: null,
  },
};

export const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_NEW_PATIENT:
      return { ...action.payload };
    case SET_NEW_PATIENT_ID:
      return {
        ...state,
        PatientDetails: {
          ...state.PatientDetails,
          IDNumber: action.payload,
        },
      };
    case SET_INIT_PATIENT:
      return INIT_STATE;
    default:
      return INIT_STATE;
  }
};
